module.exports = __webpack_public_path__ + "img/4-yards.26a7206a.svg";